import React, { useEffect } from 'react';
import Question from './Question';
import { copyText } from '../../shared/lib/clipboard';
import { useMessage } from '../../contexts/MessageContext';
import './HelpPage.css';

import { ReactComponent as SideIcon } from '../../assets/icons/sideArrow.svg';
import { ReactComponent as ChatIcon } from '../../assets/icons/chat.svg';
import { ReactComponent as MailIcon } from '../../assets/icons/mail.svg';
import { ReactComponent as PhoneIcon } from '../../assets/icons/phone.svg';

const HelpPage = () => {
  const showMessage = useMessage();
  let [questions, setQuestions] = React.useState([]);

  useEffect(() => {
    return () => {
      if (window.Tawk_API?.hideWidget) {
        try {
          window.Tawk_API.minimize();
        } catch {}
      }
    };
  }, []);

  useEffect(() => {
    fetch(process.env.REACT_APP_SERVER_URL + '/api/get-faq', {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setQuestions(data.faq);
        }
      })
      .catch(error => console.log(error));

  }, []);

  return (
    <div className="page-shell page-shell--spacious help-page">
      <h2 className="page-header">Help</h2>

      <div className="page-content-shell">
      <section className="section-box--wide section-stack">
        <h4 className="section-title">Frequently Asked Questions</h4>
        <div className="help-faq-list">
          {questions.map((q, i) => (
            <Question key={i}
                      question={q.question}
                      answer={q.answer} />
          ))}
        </div>
      </section>

      <section className="section-box--wide section-stack">
        <h4 className="section-title">Help & Feedback</h4>
        <div className="help-contact-grid">
          <button className="help-contact-card"
                  type="button"
                  onClick={() => {
                    if (window.Tawk_API?.toggle) {
                      window.Tawk_API.toggle();
                      return;
                    }

                    showMessage('Live chat is unavailable right now.');
                  }}>
            <div className="help-contact-card__content">
              <ChatIcon className="icon base help-contact-card__icon" />
              <span>Live chat</span>
            </div>
            <SideIcon className="icon sm help-contact-card__arrow" />
          </button>

          <button className="help-contact-card"
                  type="button"
                  onClick={() => {
                    copyText('team@polygraph.net');
                    showMessage('Email address copied to clipboard.');
                  }}>
            <div className="help-contact-card__content">
              <MailIcon className="icon base help-contact-card__icon" />
              <span>team@polygraph.net</span>
            </div>
          </button>

          <button className="help-contact-card"
                  type="button"
                  onClick={() => {
                    copyText('+49 (030) 2204 4851');
                    showMessage('Telephone number copied to clipboard.');
                  }}>
            <div className="help-contact-card__content">
              <PhoneIcon className="icon base help-contact-card__icon" />
              <span>+49 (030) 2204 4851</span>
            </div>
          </button>
        </div>
      </section>
      </div>
    </div>
  );
};

export default HelpPage;
